import DashboardActionTypes from './dashboard-types'

export const startFetchDashboards = data => ({
    type: DashboardActionTypes.START_FETCH_DASHBOARDS,
    payload: data,
})

export const successFetchDashboards = data => ({
    type: DashboardActionTypes.SUCCESS_FETCH_DASHBOARDS,
    payload: data,
})
